import type React from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { OverflowTooltipWithObserver } from "app/pages/sales-intelligence/common-components/OverflowTooltipWithObserver/OverflowTooltipWithObserver";
import { WEBSITE_ANALYSIS_PERFORMANCE } from "app/pages/sales-intelligence/constants/routes";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import {
    StyledBaseCell,
    StyledIconContainer,
    StyledTextAnchor,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/SiteCell/styles";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type Props = { value: string | undefined };

export const SiteCell: React.FC<Props> = ({ value }) => {
    const companyName = useCompanyName();

    const handleClick = () => {
        companyAnalysisTrackingService.widgets.trackDigitalAssetsDomainClick(companyName, value ?? "");
    };

    return (
        <StyledBaseCell>
            {value ? (
                <>
                    <StyledIconContainer>
                        <SWReactIcons
                            iconName="globe"
                            size="xs"
                            iconColor={colorsPalettes.carbon[400]}
                        />
                    </StyledIconContainer>
                    <div onMouseDown={handleClick}>
                        <StyledTextAnchor
                            href={proNavigator.href(WEBSITE_ANALYSIS_PERFORMANCE, {
                                key: value,
                                isWWW: "*",
                                duration: "3m",
                                country: 999,
                            })}
                        >
                            <OverflowTooltipWithObserver text={value} />
                        </StyledTextAnchor>
                    </div>
                </>
            ) : (
                "-"
            )}
        </StyledBaseCell>
    );
};
